import * as React from "react";
import { connect } from "react-redux";
import { setScreenName } from "../../actions";

import {
  Router as RouterComponent,
  RouterProps,
} from "../../components/Router/Router";

interface RouterContainerProps extends RouterProps {
  setScreenName: typeof setScreenName;
}

class Router extends React.Component<RouterContainerProps> {
  render() {
    return <RouterComponent {...this.props} />;
  }
}

export default connect(null, { setScreenName })(Router);
